import Layout from "../include/layout";
import { Link, useNavigate } from "react-router-dom";
import { myroutes } from "../../routes/webroute";
import { useEffect, useState } from "react";
import $ from "jquery"
import Swal from "sweetalert2";
import dayjs from "dayjs";
import 'datatables.net-dt/js/dataTables.dataTables'
import 'datatables.net-dt/css/jquery.dataTables.css'
import { Button } from "react-bootstrap";
import StatutsService from "../../services/StatutsService";
import AuteursService from "../../services/AuteursService";
import { useSelector } from "react-redux";

export default function IndexAuteurs() {

    //##########################/// METHODES ##########################///
    const [auteurs, setAuteurs] = useState([])
    const navigate = useNavigate();
    const token = useSelector(state => state.auth.token)

    //get liste auteurs
    const fetchAuteurs = async () => {
        await AuteursService.index(token).then((res) => {
            setAuteurs(res.data.liste_auteurs)
        }).catch(error => {
            console.log(error)
        })

        //initialize datatable
        $(document).ready(function () {
            $('.data-table').DataTable();
        });

    }

    //redirection sur la page edit sans afficher les id dans l'url
    const goToEdit = (param) => {
        navigate(myroutes.auteurs_edit, { state: { id: param } })
    }

    //redirection sur la page d'aperçu sans afficher les id dans l'url
    const goToShow = (param) => {
        navigate(myroutes.auteurs_show, { state: { id: param } })
    }

    //suppression d'un élément
    const onDelete = (param) => {
        //confirm action
        Swal.fire({
            icon: "warning",
            text: "Voulez-vous confirmer cette action ?",
            showCancelButton: true,
            cancelButtonText: "Non",
            confirmButtonText: "Oui",
            confirmButtonColor: "red"
        }).then(result => {
            if (result.isConfirmed) {
                AuteursService.delete(param,token).then((response) => {
                    if (response.data.erreur) {
                        Swal.fire({
                            icon: "error",
                            text: response.data.erreur
                        })
                    } else {
                        Swal.fire({
                            icon: "success",
                            text: response.data.message
                        })
                        fetchAuteurs()
                    }
                }).catch(e => {
                    Swal.fire({
                        icon: "error",
                        text: e.message
                    })
                })
            }
        })
    }

    //Rendre actif ou inactif un user
    const updateStatut = async (id, statut, table) => {
        //let form = { id, statut, table }
        await StatutsService.changeStatut(id, statut, table,token).then(response => {
            if (response.data.erreur) {
                Swal.fire({
                    icon: "error",
                    text: response.data.erreur
                })
            } else {
                Swal.fire({
                    icon: "success",
                    text: response.data.message
                })
                fetchAuteurs()
            }
        }).catch(error => {
            console.log(error)
        })
    }

    useEffect(() => {
        fetchAuteurs();
        $("#submenu-2").addClass("show")
    }, [])


    //##########################/// END METHODES ##########################///


    return (
        <Layout>
            <div className="app-content pt-3 p-md-3 p-lg-4 app-card app-card-stat">
                <div className="container-xl app-card-body">

                    <div className="row g-3 align-items-center justify-content-between">
                        <div className="col-auto">
                            <div className="pagetitle">
                                <h1 className="app-page-title mb-0">Gestion</h1>
                                <nav>
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item"><Link to={myroutes.dashboard} >Accueil</Link></li>
                                        <li className="breadcrumb-item active">Auteurs </li>
                                    </ol>
                                </nav>
                            </div>
                        </div>
                    </div>{/*//row*/}

                    <div className="row g-3 mb-4 align-items-center justify-content-between">
                        <div className="col-auto">
                            <h1 className="app-page-title mb-0">Liste des Auteurs <Link className="btn btn-primary btn-sm" to={myroutes.auteurs_create} title="Ajouter" ><i className="fa fa-plus-circle"></i></Link> </h1>
                        </div>
                        <div className="col-auto">
                            <div className="page-utilities">
                                <div className="row g-2 justify-content-start justify-content-md-end align-items-center">

                                    <div className="col-auto">
                                        <a className="btn app-btn-primary" href="#">
                                            <i className="fas fa-file-excel"></i>&nbsp;
                                            Excel
                                        </a>
                                    </div>
                                    <div className="col-auto">
                                        <a className="btn btn-danger" href="#">
                                            <i className="fas fa-file-pdf"></i>&nbsp;
                                            Pdf
                                        </a>
                                    </div>
                                </div>{/*//row*/}
                            </div>{/*//table-utilities*/}
                        </div>{/*//col-auto*/}
                    </div>{/*//row*/}

                    <div className="app-card app-card-orders-table shadow-lg mb-5">
                        <div className="app-card-body mx-3 py-2">
                            <div className="table-responsive mt-4">
                                <table className="table table-borderless table-hover app-table-hover mb-0 data-table">
                                    <thead className="bg-primary">
                                        <tr>
                                            <th className="cell text-white">N°</th>
                                            <th className="cell text-white">Nom auteur </th>
                                            <th className="cell text-white">Nom Interlocuteur</th>
                                            <th className="cell text-white">Qualite</th>
                                            <th className="cell text-white">Présentation</th>
                                            <th className="cell text-white">Telephone</th>
                                            <th className="cell text-white">Statuts</th>
                                            <th className="cell text-white">Date modification</th>
                                            <th className="cell text-white">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody className="table-group-divider" style={{textAlign : "left"}}>
                                        {auteurs.length > 0 && auteurs.map((item, index) => (
                                            <tr key={index}>
                                                <td className="cell">{index + 1}</td>
                                                <td className="cell">{item.nom_auteur} </td>
                                                <td className="cell">{item.nom_interlocuteur + " " + item.prenoms_interlocuteur} </td>
                                                <td className="cell">{item.qualite} </td>
                                                <td className="cell"><span className="truncate">{item.presentation}</span></td>
                                                <td className="cell">{item.telephone} </td>
                                                <td className="cell"><span className={(item.get_statut.libelle === "ACTIF") ? "badge bg-success" : "badge bg-danger"}>{item.get_statut.libelle}</span></td>
                                                <td className="cell"><span>{dayjs(item.updated_at).format("DD/MM/YYYY H:m:s")} par </span>
                                                    <span className="notex">{item.updated_by ? item.get_updatedby.nom : ''} {item.updated_by ? item.get_updatedby.prenoms : ''}</span>
                                                </td>
                                                <td className="cell justify-content-center d-flex">
                                                    <Button className={item.get_statut.libelle === "ACTIF" ? "btn btn-sm btn-success" : "btn btn-sm btn-dark"} onClick={() => updateStatut(item.id, (item.get_statut.libelle === "ACTIF" ? "desactivation" : "activation"), "auteurs")} title="Changer le statut">
                                                        <i className={item.get_statut.libelle === "ACTIF" ? "fas fa-eye" : "fas fa-eye-slash"}></i></Button>&nbsp;&nbsp;
                                                    <Button className="btn btn-sm btn-primary" onClick={() => goToEdit(item.id)} title="Modifier">
                                                        <i className="fas fa-edit"></i></Button>&nbsp;&nbsp;
                                                    <Button className="btn btn-sm btn-success" onClick={() => goToShow(item.id)} title="Détails">
                                                        <i className="fas fa-list"></i></Button>&nbsp;&nbsp;
                                                    <Button className="btn btn-sm btn-danger" onClick={() => onDelete(item.id)} title="Supprimer">
                                                        <i className="fas fa-trash"></i></Button>
                                                </td>
                                            </tr>
                                        ))}


                                    </tbody>
                                </table>
                            </div>{/*//table-responsive*/}

                        </div>{/*//app-card-body*/}
                    </div>
                    {/*//app-card*/}

                    {/*//End table-content*/}


                </div>{/*//container-fluid*/}
            </div>{/*//app-content*/}
        </Layout>
    )
}